export default [
  {
    id: 1,
    src: './static/soundtrack/deadly-arcade.mp3',
    name: 'LOCALE.SOUNDTRACK.THEME',
    color: '#368b82',
  },
  {
    id: 2,
    src: './static/soundtrack/papelitos.mp3',
    name: 'LOCALE.SOUNDTRACK.CARTOON',
    color: '#9c404d',
  },
  {
    id: 3,
    src: './static/soundtrack/heladitos.mp3',
    name: 'LOCALE.SOUNDTRACK.MEDIEVAL',
    color: '#ddbb44',
  },
  {
    id: 4,
    src: './static/soundtrack/raritos.mp3',
    name: 'LOCALE.SOUNDTRACK.TERROR',
    color: '#bf5495',
  },
  {
    id: 5,
    src: './static/soundtrack/muertitos.mp3',
    name: 'LOCALE.SOUNDTRACK.ZOMBIE',
    color: '#42318a',
  },
];
